/* eslint-disable no-console */
import React from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import classNames from 'classnames';
import ReCAPTCHA from 'react-google-recaptcha';

import { ArrRight } from '@/icons/index';
import { envVariables } from '@/constants/index';

import Modal from '../Modal/Modal';
import Input from '../Input/Input';
import PasswordInput from '../PasswordInput/PasswordInput';
import Button from '../Button/Button';

import styles from './LoginModal.module.scss';

const FormSchema = Yup.object().shape({
  phone: Yup.string().required('Required').length(13),
  password: Yup.string()
    .required('No password provided.')
    .min(8, 'Password is too short - should be 8 chars minimum.')
    .matches(/[a-zA-Z]/, 'Password can only contain Latin letters.'),
});

const FormSchemaPassword = Yup.object().shape({
  phone: Yup.string().required('Required').length(13),
  password: Yup.string()
    .required('No password provided.')
    .min(8, 'Password is too short - should be 8 chars minimum.')
    .matches(/[a-zA-Z]/, 'Password can only contain Latin letters.'),
  password2: Yup.string()
    .required('No password provided.')
    .min(8, 'Password is too short - should be 8 chars minimum.')
    .matches(/[a-zA-Z]/, 'Password can only contain Latin letters.'),
});

const LoginModal = ({
  active = false,
  setActive = () => null,
  setUser = () => null,
}) => {
  const [signUp, setSignUp] = React.useState(false);
  const [passwordRestore, setPasswordRestore] = React.useState(false);
  const [passwordRestoreFlow, setPasswordRestoreFlow] = React.useState('phone');

  const onChangeCaptcha = (value) => {
    console.log('Captcha value:', value);
  };

  React.useEffect(() => {
    setTimeout(() => {
      setPasswordRestoreFlow('phone');
    }, 300);
  }, [passwordRestore]);

  const formik = useFormik({
    initialValues: {
      phone: '',
      password: '',
    },
    validationSchema: FormSchema,
    onSubmit: () => {
      setUser(true);
    },
  });

  const formikSingUp = useFormik({
    initialValues: {
      phone: '',
      password: '',
      password2: '',
    },
    validationSchema: FormSchemaPassword,
    onSubmit: () => {
      setUser(true);
    },
  });

  const formikPasswordFlowPhone = useFormik({
    initialValues: {
      phone: '',
    },
    onSubmit: () => {
      setPasswordRestoreFlow('code');
    },
  });

  const formikPasswordFlowCode = useFormik({
    initialValues: {
      code: '',
    },
    onSubmit: () => {
      setPasswordRestoreFlow('password');
    },
  });

  const formikPasswordFlowPassword = useFormik({
    initialValues: {
      password: '',
      password1: '',
    },
    onSubmit: () => {
      setPasswordRestore(false);
    },
  });

  return (
    <>
      <Modal
        active={active}
        setActive={setActive}
        className={styles.modal}
        itemScope
        itemType='https://schema.org/CheckInAction'
      >
        <div className={'title'}>
          Login <span className={styles.title}>Bakcell</span>
        </div>
        <div className={styles.form}>
          <Input
            // error
            value={formik.values.phone}
            onBlur={formik.handleBlur('phone')}
            onChange={(value) => formik.setFieldValue('phone', value)}
            label={'Phone'}
            type='tel'
            placeholderMask={'+994'}
            placeholder={'+994 (XXX) XXX XX-XX'}
            mask={'+\\9\\9\\4-999-999-99-99'}
          />
          <PasswordInput
            // error={<span className={styles.error}>Incorrect phone or password</span>}
            onBlur={formik.handleBlur('password')}
            onChange={(value) => formik.setFieldValue('password', value)}
            placeholder={'Password'}
          />
          <div className={styles.forgotPassword}>
            <button
              className={styles.button}
              onClick={() => {
                setPasswordRestore(true);
                setSignUp(false);
                setActive(false);
              }}
            >
              Forgot password?
            </button>
          </div>
          <div className={styles.reCAPTCHA}>
            <div className={styles.text}>
              Please check box below to proceed.
            </div>
            <ReCAPTCHA
              sitekey={envVariables.NEXT_PUBLIC_RECAPTCHA_API_KEY || 'default'}
              onChange={onChangeCaptcha}
            />
          </div>
          <Button
            className={styles.login}
            onClick={() => {
              setUser(true);
              setActive(false);
            }}
          >
            Login <ArrRight width={24} />
          </Button>
          <div className={styles.signUpContainer}>
            <span>
              Don&#39;t have an account yet?
              <button
                className={styles.signUp}
                onClick={() => {
                  setSignUp(true);
                  setActive(false);
                }}
              >
                Sign up
              </button>
            </span>
          </div>
        </div>
      </Modal>
      <Modal active={signUp} setActive={setSignUp} className={styles.modal}>
        <div className={'title'}>
          Sign up <span className={styles.title}>Bakcell</span>
        </div>
        <div className={styles.form}>
          <Input
            value={formikSingUp.values.phone}
            onBlur={formikSingUp.handleBlur('phone')}
            onChange={(value) => formikSingUp.setFieldValue('phone', value)}
            label={'Phone'}
            type='tel'
            placeholderMask={'+994'}
            placeholder={'+994 (XXX) XXX XX-XX'}
            mask={'+\\9\\9\\4-999-999-99-99'}
          />
          <PasswordInput
            onBlur={formikSingUp.handleBlur('password')}
            onChange={(value) => formikSingUp.setFieldValue('password', value)}
            placeholder={'Password'}
          />
          <PasswordInput
            onBlur={formikSingUp.handleBlur('password2')}
            onChange={(value) => formikSingUp.setFieldValue('password2', value)}
            placeholder={'Repeat password'}
          />
          <div className={styles.reCAPTCHA}>
            <div className={styles.text}>
              Please check box below to proceed.
            </div>
            <ReCAPTCHA
              sitekey={envVariables.NEXT_PUBLIC_RECAPTCHA_API_KEY || 'default'}
              onChange={onChangeCaptcha}
            />
          </div>
          <Button
            className={styles.login}
            onClick={() => {
              setUser(true);
              setSignUp(false);
            }}
          >
            Sign up <ArrRight width={24} />
          </Button>
          <div className={styles.signUpContainer}>
            <span>
              Don&#39;t have an account yet?
              <button
                className={styles.signUp}
                onClick={() => {
                  setActive(true);
                  setSignUp(false);
                }}
              >
                Login
              </button>
            </span>
          </div>
        </div>
      </Modal>
      <Modal
        active={passwordRestore}
        setActive={setPasswordRestore}
        className={styles.modal}
      >
        <div className={'title'}>
          Password <span className={styles.title}>Recovery</span>
        </div>
        {passwordRestoreFlow === 'phone' && (
          <div className={styles.form}>
            <Input
              value={formikPasswordFlowPhone.values.phone}
              onBlur={formikPasswordFlowPhone.handleBlur('phone')}
              onChange={(value) =>
                formikPasswordFlowPhone.setFieldValue('phone', value)
              }
              label={'Phone'}
              type='tel'
              placeholderMask={'+994'}
              placeholder={'+994 (XXX) XXX XX-XX'}
              mask={'+\\9\\9\\4-999-999-99-99'}
            />
            <Button
              className={classNames([styles.login, styles.password])}
              onClick={formikPasswordFlowPhone.handleSubmit}
            >
              Next <ArrRight width={24} />
            </Button>
          </div>
        )}
        {passwordRestoreFlow === 'code' && (
          <div className={styles.form}>
            <PasswordInput
              label={'SMS-Code'}
              onBlur={formikPasswordFlowCode.handleBlur('code')}
              onChange={(value) =>
                formikPasswordFlowCode.setFieldValue('code', value)
              }
            />
            {/* <span className={styles.code}> Send code again 0:56</span> */}
            <span className={classNames([styles.code, styles.codeAgain])}>
              Send code again
            </span>
            <Button
              className={classNames([styles.login, styles.loginCode])}
              onClick={formikPasswordFlowCode.handleSubmit}
            >
              Next <ArrRight width={24} />
            </Button>
          </div>
        )}
        {passwordRestoreFlow === 'password' && (
          <div className={styles.form}>
            <PasswordInput
              label={'New Password'}
              onBlur={formikPasswordFlowPassword.handleBlur('password')}
              onChange={(value) =>
                formikPasswordFlowPassword.setFieldValue('password', value)
              }
            />
            <PasswordInput
              label={'Confirm Password'}
              onBlur={formikPasswordFlowPassword.handleBlur('password1')}
              onChange={(value) =>
                formikPasswordFlowPassword.setFieldValue('password1', value)
              }
            />
            <Button
              className={classNames([styles.login, styles.password])}
              onClick={formikPasswordFlowPassword.handleSubmit}
            >
              Save New Password
            </Button>
          </div>
        )}
      </Modal>
    </>
  );
};

export default LoginModal;
